import $apiIndex from "@/api/index";
export default {
  state: {
    lang: 2,
  },
  mutations: {
    SET_LANG(state, value) {
      state.lang = value;
    },
  },
  actions: {
    //获取当前语言
    // setlang({ commit }, data) {
    //   console.log("actions", data);
    //   commit("GET_LANG", data);
    // },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/message.js